var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{staticClass:"fill-height d-flex dark justify-center pa-0",staticStyle:{"background":"#f2f2f2"},attrs:{"fluid":"","width":"100%"}},[_c(_setup.LoginForm)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }